import axios from 'axios';
import SSO from '../utilities/sso'

let cityData = null

const Api = function () {
    let client = axios.create()

    this.getLanguage = () => {
        return `${document.documentElement.lang}`.toLowerCase();
    }

    this.get = (endpoint, params) => {
        return client.get(endpoint, {
            params: {...params, token: SSO.getToken()},
        });
    }

    this.delete = (endpoint, params) => {
        return client.delete(endpoint, {
            params: {...params, token: SSO.getToken()},
        });
    }

    this.post = (endpoint, data) => {
        return client.post(endpoint, { ...data, lang: this.getLanguage() }, {
            params: { token: SSO.getToken() },
        });
    }

    this.put = (endpoint, data) => {
        return client.put(endpoint, { ...data, lang: this.getLanguage() }, {
            params: { token: SSO.getToken() },
        });
    }

    this.setOptions = o => {
        client = axios.create(o)
    }

    this.getHistory = () => {
        return this.get('pool-configurations')
    }

    this.getPool = id => {
        return this.get(`pool-configurations/${id}`)
    }

    this.deletePool = id => {
        return this.delete(`pool-configurations/${id}`)
    }

    this.getCityData = async () => {
        if (!cityData) {
            cityData = await this.get('/pool-configurations/city-data')
        }

        return cityData;
    }

    this.getProducts = () => {
        // This returns back a different list of products per customer.
        return this.get('pool-configurations/products')
    }

    this.getPrintRender = (id, params) => {
        return this.get(`/pool-configurations/${id}/print`, params)
    }

    this.updateConfiguration = (id, data) => {
        return this.put(`pool-configurations/${id}`, data)
    }

    this.createConfiguration = (data) => {
        return this.post('pool-configurations', data)
    }
}

export default new Api;
